<template>
  <header>
    <section class="hero is-info is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <h1 class="title is-1 has-text-light">
              Conor O'Riordan
            </h1>
            <h2 class="subtitle is-2 has-text-info-light">
              Full-Stack Developer
            </h2>
            <br />
            <button class="button is-info is-inverted is-outlined is-large" @click="scrollTo">Main Projects</button>
          </div>
        </div>
    </section>
  </header>
</template>

<script>
export default {
  methods: {
    scrollTo () {
      this.$emit("scroll-to", "mainProjects");
    }
  }
}
</script>

<style scoped>
.hero {
    background-image: url("https://images.unsplash.com/photo-1597773085733-aff8dd84b6e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80");
    background-size: cover;
    background-position: bottom;
}
</style>
